<template>
  <div class="goods-out-block" :class="{'hasBuyBtn':hasBuyBtn}">
  	<a href="javascript:void(0)" class="goods-item-mask" v-if="!readOnly"></a>
  	<div class="select-opt" v-if="selecteable">
  		<check-item @clickItem="selectItem" :itemChecked="goodsData.if_checked=='1'"></check-item>
  	</div>
    <template v-if="!isDetailItem">
      <div class="goods-avatar">
        <i class="goods-tag" v-show="goodsData.tagType">{{goodsData.tagType}}</i>
        <img class="goods-avatar" :src="goodsData.img_url" />
      </div>

      <div class="goods-info-box">
        <h3 class="goods-name">{{goodsData.cn_name}}</h3>
        <h3 class="goods-name">{{goodsData.en_name}}</h3>
        <p>
          <label class="goods-attr">货号:<span>{{goodsData.p_code}}</span></label>
          <label class="goods-attr">CAS号:<span>{{goodsData.cas}}</span></label>
        </p>
        <p>
          <label class="goods-attr">浓度级别:<span>{{goodsData.level}}</span></label>
        </p>
        <p>
          <label class="goods-price">
            <span class="discont">￥{{goodsData.price}}</span>
            <span class="oranginal" style="text-decoration: none;">￥{{goodsData.amount}}</span>
          </label>
        </p>

        <div class="numer-selector-wapper">
          <p v-if="readOnly">
            x {{goodsData.num}}
          </p>
          <number-selector v-else :maxNum="goodsData.maxNum?goodsData.maxNum:99999" :minNum="1" :orNum="Number(goodsData.num)" @changeNum="changeNum"></number-selector>
        </div>
        <button class="goods-buy-btn" v-if="hasBuyBtn" @click.stop="putItemNum()"><i v-show="goodsData.buyNum">{{goodsData.buyNum}}</i></button>
      </div>
    </template>
    <template v-else>
      <div class="goods-info-box" style="padding-left:0;">
        <h3 class="goods-name">{{goodsData.p_cn_name}}</h3>
        <h3 class="goods-name">{{goodsData.en_name}}</h3>
        <p>
          <label class="goods-attr">货号:<span>{{goodsData.p_code}}</span></label>
          <label class="goods-attr">CAS号:<span>{{goodsData.c_cas}}</span></label>
        </p>
        <p>
          <label class="goods-attr">浓度级别:<span>{{goodsData.p_level}}</span></label>
        </p>
        <p>
          <label class="goods-price">
            <span class="discont">￥{{goodsData.si_discount}}</span>
            <span class="oranginal">￥{{goodsData.si_price}}</span>
          </label>
        </p>

        <div class="numer-selector-wapper">
          <p v-if="readOnly">
            x {{goodsData.si_num}}=
            <span class="discont" style="color:red;">￥{{goodsData.si_amount}}</span>
          </p>
        </div>
        <button class="goods-buy-btn" v-if="hasBuyBtn" @click.stop="putItemNum()"><i v-show="goodsData.buyNum">{{goodsData.si_num}}</i></button>
      </div>
    </template>
  </div>
</template>

<script>
  import CheckItem from 'basic/checkItem/checkItem'
  import NumberSelector from 'basic/numberSelector/numberSelector'
	export default {
    name: 'searchIndex',
    data () {
      return {
      }
    },
    props:{
      goodsData:{
      	type:Object,
      	default () {
		      return {}
		    }
      },
      selecteable:{
      	type:Boolean,
      	default:false
      },
      index:{
      	type:Number,
      	default:0
      },
      readOnly:{
      	type:Boolean,
      	default:false
      },
      hasBuyBtn:{
      	type:Boolean,
      	default:false
      },
      isDetailItem:{
      	type:Boolean,
      	default:false
      }
    },
    computed:{
    },
    methods:{
    	selectItem(){
    		this.$emit('selectItem',this.index);
    	},
    	changeNum(num){
    		this.$emit('changeItemNum',this.index,num);
    	},
    	putItemNum(){
    		this.$emit('putItemNum',this.index,this.goodsData.selectedNum);
    	}
    },
    components:{
        CheckItem,NumberSelector
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" type="text/scss" rel="stylesheet/scss" scoped>
.goods-out-block{
	position:relative;
	padding: .1rem;
	display: flex;
	align-items: center;
	box-sizing: border-box;
	&.hasBuyBtn{
		 .goods-info-box .numer-selector-wapper{
			position:absolute;
			right: .1rem;
			top: .2rem;
		}
	}
	.goods-item-mask{
		position:absolute;
		top:0;
		left:0;
		right:0;
		bottom:0;
		background-color: rgba(0,0,0,0);
		&:active{
		background-color: rgba(0,0,0,.2);
		}
	}
	.select-opt{
		position:relative;
		width: .35rem;
		z-index: 10;
	}
	.goods-avatar{
		position:relative;
		img{
			width: .7rem;
			height:.65rem;
			border: 1px solid #eee;
		}
		.goods-tag{
			position:absolute;
			padding:.02rem;
			top: 0;
			right:0;
			font-size:.10rem;
			color: #fff;
			z-index: 10;
			&:after{
				content:"";
				position:absolute;
				top:-.18rem;
				right:-.18rem;
				border: .18rem solid transparent;
				border-top-color: $mainColor;
				transform: rotateZ(-135deg);
				z-index: -1;
			}
		}

	}
	.goods-info-box{
		padding-left: .1rem;
		width: 100%;
		font-size: .12rem;
		line-height: .18rem;
		color: #333;
		box-sizing: border-box;
		.goods-name{

		}
		p{
			.goods-attr{
				padding-right: .05rem;
				color: #999;
				span{
					padding-left: .05rem;
					color:#333;
				}
			}
			.goods-price{
				span{
					padding-right: .05rem;
					&.discont{
						color: $mainColor;
					}
					&.oranginal{
						color: #999;
						text-decoration: line-through;
					}
				}
			}
		}
		.numer-selector-wapper{
			position:relative;
			z-index: 10;
			margin-top: -.14rem;
			float:right;
		}
		.goods-buy-btn{
			position:relative;
			z-index: 10;
			margin-top: -.14rem;
			margin-right: .15rem;
			float:right;
			width: .25rem;
			height:.25rem;
			border:none;
			background:url(../../assets/list-buy-icon.png) no-repeat center;
			background-size: .25rem .25rem;
			>i{
				position: absolute;
		    top: -.1rem;
		    left: 60%;
		    width: .21rem;
		    height: .21rem;
		    line-height: .21rem;
		    font-size: .12rem;
		    color: #fff;
		    text-align: center;
		    border-radius: .2rem;
		    background-color: $mainColor-light1;
			}
		}
	}
}

</style>



// WEBPACK FOOTER //
// src/basic/orderItem/orderItem.vue